import React from 'react';

import BaseRangeRules from 'components/Tvendo/Sale/QuotaBPartner/RangeRules/List.js';

export default function () {
  return <BaseRangeRules />;
}
